import { DropDownList } from '@progress/kendo-react-dropdowns'
import { useComponentProperties } from '../../../../Hooks/Display/useComponentProperties';
import { useEffect, useState } from 'react';
import { usePortalPages } from '../../../../Hooks/Display/usePages';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import { useTranslation } from 'react-i18next';

function EventActions() {

    const selectedComponent = useSelectedComponent();
    
    const portalPages = usePortalPages();

    const [properties, setProperty] = useComponentProperties();

    const [newRecordPages, setNewRecordPages] = useState([]);
    const [editRecordPages, setEditRecordPages] = useState([]);

    const { t } = useTranslation("display/components/calendar");

    useEffect(() => {
        if (portalPages && portalPages.length > 0) {
            const newRecordPages = portalPages.filter(page => page.subPageType === "New Record");
            const editRecordPages = portalPages.filter(page => page.subPageType === "Edit Record");
            setNewRecordPages(newRecordPages);
            setEditRecordPages(editRecordPages);
        }
    }, [portalPages])

    function handleAddPage(e) {
        setProperty("addPage", e.target.value)
    }

    function handleEditPage(e) {
        setProperty("editPage", e.target.value)
    }

    return (
        <>
            {
                newRecordPages.length > 0 ?
                    <div className='d-flex'>
                        <div className="me-2">
                            <div className="form-label">
                                {t("form_labels.event_actions.add_page", { ns: "display/components/calendar" })}
                            </div>
                            <DropDownList
                                disabled={selectedComponent.hidden}
                                onChange={handleAddPage}
                                value={properties.addPage}
                                data={newRecordPages}
                                textField='pageName'
                                dataItemKey='_id'
                                style={{ width: "200px" }}
                            />
                        </div>
                        <div className="me-2">
                            <div className="form-label">
                                {t("form_labels.event_actions.edit_page", { ns: "display/components/calendar" })}
                            </div>
                            <DropDownList
                                disabled={selectedComponent.hidden}
                                onChange={handleEditPage}
                                value={properties.editPage}
                                data={editRecordPages}
                                textField='pageName'
                                dataItemKey='_id'
                                style={{ width: "200px" }}
                            />
                        </div>
                    </div>
                    :
                    <div className='col'>
                        { t("form_labels.event_actions.no_new_record_error", { ns: "display/components/calendar" }) }
                    </div>
            }
        </>
    )
}

export default EventActions;